export default "__VITE_ASSET__CUCMyOjD__"